import React, { useCallback, useMemo, useState } from 'react';
import { BsFolderPlus } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../../services/actions';
import Bouton from '../../UI/Bouton/Bouton';
import DataGrid from '../../UI/DataGrid/DataGrid';
import Toolbar from '../../UI/Toolbar/Toolbar';
import styles from './TableauProjet.module.scss';

const COLUMN_CONFIG = [
  ['project_id', 'id', 120],
  ['project_name', 'nom', 200],
  ['groupe', 'groupe', 150],
  ['description', 'description_de_projet', 220],
  ['parent_id', 'id_du_projet_parent', 170],
  ['project_image', 'image_de_projet', 160],
  ['active', 'etat', 120],
  ['geo_barr', 'geo_barriere', 150],
];

const createColumn = (field, labelKey, width) => ({
  field,
  headerName: checkMot(labelKey),
  flex: 1,
  minWidth: width,
  sortable: true,
  align: 'center',
  headerAlign: 'center',
});

const TableauProjet = ({ creer, projetSelectione }) => {
  const dispatch = useDispatch();
  const listeProjets = useSelector((state) => state.authentifie.projects_list);

  const [selectionModel, setSelectionModel] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const columns = useMemo(
    () =>
      COLUMN_CONFIG.map(([field, labelKey, width]) =>
        createColumn(field, labelKey, width)
      ),
    []
  );

  const handleSelectionChange = useCallback(
    (newSelection) => {
      setSelectionModel(newSelection);
      if (newSelection.length > 0) {
        const selectedRow = (listeProjets || []).find(
          (row) => row.project_id === newSelection[0]
        );
        if (selectedRow) {
          projetSelectione(selectedRow);
        }
      }
    },
    [listeProjets, projetSelectione]
  );

  const handleRefresh = useCallback(() => {
    dispatch(actions.reqRecupererListeProjets());
  }, [dispatch]);

  const handleSearchChange = useCallback((e) => {
    setSearchValue(e.target.value);
  }, []);

  const handleSearchClear = useCallback(() => {
    setSearchValue('');
  }, []);

  const filteredRows = useMemo(() => {
    if (!listeProjets) return [];
    if (!searchValue) return listeProjets;

    const needle = searchValue.toLowerCase();
    return listeProjets.filter((projet) =>
      Object.values(projet).some((value) =>
        String(value).toLowerCase().includes(needle)
      )
    );
  }, [listeProjets, searchValue]);

  return (
    <div className={styles.Tableau}>
      <Toolbar
        searchValue={searchValue}
        onSearchChange={handleSearchChange}
        onSearchClear={handleSearchClear}
        searchPlaceholder="recherche"
        onRefresh={handleRefresh}
        refreshRequestType={requestType.recuperation_de_la_liste_des_projets}
        refreshMessage={checkMot('maj_projets_en_cour')}
      >
        <Bouton
          hoverText={checkMot('creer')}
          type={type_btn.outil}
          rond={true}
          cliquer={creer}
        >
          <BsFolderPlus size={15} />
        </Bouton>
      </Toolbar>
      <div className={styles.TableauBootstrap}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          getRowId={(row) => row.project_id}
          rowSelectionModel={selectionModel}
          onRowSelectionModelChange={handleSelectionChange}
          disableMultipleRowSelection
        />
      </div>
    </div>
  );
};

export default TableauProjet;
